import React, { useEffect, useState } from 'react';
import { useLoader } from '@react-three/fiber';
/* @ts-ignore */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { useGameController } from './hooks/useGameController.ts';
import { MeshCollider, RigidBody } from '@react-three/rapier';
import { useFBX } from '@react-three/drei';
import Wall from './Wall.tsx';
import { Material } from 'three';
import { applyRealisticMaterials } from './utils/materialUtils.ts';

export default function Scene({ isActive, model, collider, music}) {
    const gameController = useGameController();
    const rb = React.useRef();
    const gltfScene = useLoader(GLTFLoader, collider);
    const gltfDecoration = useLoader(GLTFLoader, model);
    //const [fbx, setFbx] = useState(useFBX(collider));

    useEffect(()=>{
        // Apply realistic materials to reduce plastic look
        if (gltfScene?.scene) {
            applyRealisticMaterials(gltfScene.scene);
            // Enable shadows on all meshes in the terrain - only receive shadows
            gltfScene.scene.traverse((child) => {
                if (child.isMesh) {
                    child.receiveShadow = true;
                    child.castShadow = true; // Terrain doesn't cast shadows, only receives
                }
            });
        }
        if (gltfDecoration?.scene) {
            applyRealisticMaterials(gltfDecoration.scene);
            // Decorations only receive shadows, don't cast them
            gltfDecoration.scene.traverse((child) => {
                if (child.isMesh) {
                    child.receiveShadow = true;
                    child.castShadow = true;
                }
            });
        }
    }, [gltfScene, gltfDecoration]);

    /*useEffect(()=>{
        if(!isActive) {
            gameController.getAudioController().pauseAudio(music);
        } else {
            gameController.getAudioController().playAudio(music, 0.2, 1, true);
        }
        return ()=>{
            gameController.getAudioController().pauseAudio(music);
        }
    }, [isActive]);*/

    return isActive ? (
        <group>
            <primitive position={[0,-0.05,0]} object={gltfDecoration.scene} scale={[1.0,1.0,1.0]} receiveShadow castShadow dispose={null}/>
            <RigidBody colliders="trimesh" type={'fixed'}  scale={[1,1,1]}>
                <primitive position={[0,0,0]} object={gltfScene.scene} scale={[1.0,1.0,1.0]} receiveShadow castShadow dispose={null}/>
            </RigidBody>
        </group>
    ) : null
  
};